'use es6';

import Immutable from 'immutable';
import { cleanObject } from '../utils/formatters';
const EMPTY_LIST = Immutable.List();
const defaults = {
  name: '',
  avatarUrl: null,
  websiteUrl: '',
  description: '',
  location: null,
  certifications: EMPTY_LIST
};

class DetailsResponseProvider extends Immutable.Record(defaults) {
  constructor(json = {}) {
    const jsonCopy = Object.assign({}, json);

    if (json.certifications) {
      jsonCopy.certifications = Immutable.List(json.certifications);
    }

    super(cleanObject(jsonCopy));
  }

}

export default DetailsResponseProvider;